import {Cart, CartLineItem} from '../types';

export function calculateCartTotals(
  newItems: CartLineItem[],
  initialCart: Cart
): Cart {
  const cart: Cart = {
    ...initialCart,
    items: [],
    original_total_price: 0,
    items_subtotal_price: 0,
    total_price: 0,
    item_count: 0,
    total_weight: 0,
    total_discount: 0,
  };

  for (const item of newItems) {
    cart.item_count += item.quantity;
    cart.original_total_price += item.original_line_price;
    cart.items_subtotal_price += item.final_line_price;
    cart.total_price += item.final_line_price;
    cart.total_weight += item.grams * item.quantity;
    cart.total_discount += item.total_discount;
    cart.requires_shipping ||= item.requires_shipping;
    cart.items.push(item);
  }

  return cart;
}
